import { Grid } from "@mui/material";
import { AutocompleteInput, ReferenceInput, TextInput, required } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";

const PreviousEducationSection = () => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={4}>
      <TextInput
        source="previousEducation.speciality"
        label="Специалност"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <ReferenceInput
        reference={administrationRequests.getDegreesSelect()}
        source="previousEducation.degreeId"
      >
        <AutocompleteInput
          optionText="name"
          label="Образователно-квалификационна степен"
          validate={required("Задължително")}
          fullWidth
        />
      </ReferenceInput>
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="previousEducation.qualification"
        label="Квалификация"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="previousEducation.diplomaUniversity"
        label="Висше училище"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="previousEducation.diplomaSeries"
        label="Серия на диплома"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="previousEducation.diplomaNumber"
        label="Номер на диплома"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <TextInput
        source="previousEducation.diplomaRegistrationNumber"
        label="Регистрационен номер"
        validate={required("Задължително")}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} md={4}>
      <CustomDateInput
        source="previousEducation.diplomaDate"
        label="Дата на диплома"
        noTime
        fullWidth
      />
    </Grid>
  </Grid>
);

export default PreviousEducationSection;
